const getRouteForIndex = (routes: string[], index: number, intakeId: string, offerId: string) => {
  const routeArray = routes[index].split('/');
  routeArray[1] = intakeId;
  routeArray[2] = offerId;
  return routeArray.join('/');
};

const getIndexForRoute = (routes: string[], route: string) => {
  const routeArray = route.split('/');
  routeArray[1] = ':intakeId';
  routeArray[2] = ':offerId';

  route = routeArray.join('/');
  return routes.findIndex(a => a === route);
};

export const getPageByIndex = (
  routes: string[],
  currentRoute: string,
  getNextPosition: (currentPosition: number) => number
) => {
  const routeArray = currentRoute.split('/');
  const currentPosition = getIndexForRoute(routes, currentRoute);
  if (currentRoute === '' || currentPosition === -1) {
    return '/';
  }

  return getRouteForIndex(routes, getNextPosition(currentPosition), routeArray[1], routeArray[2]);
};
